export default __webpack_public_path__ + "static/media/bu-cindy.c852b386.png";